<template>
  <b-container class="justify-content-center mt-5 mb-5">
    <div class="row justify-content-center mb-3">
      <b-row class="justify-content-center align-items-center mt-5 mf_card_bl_spl">
        <b-col cols="12" md="8" style="text-align:left">
          <div>Retrouvez ici l'ensemble de vos portefeuilles ainsi que vos propositions de portefeuilles optimisés. Le pilote automatique vous permet d'obtenir des recommandations d'achat / vente en fonction du portefeuille optimisé que vous décidez de suivre</div>
        </b-col>
      </b-row>
      <div style="display: inline-flex; align-items: center">
        <div
          style="
          text-align: right;
          font: normal normal normal Segoe UI;
          letter-spacing: 0px;
          color: #ffffff;
          opacity: 1;
          margin-right: 10px;
        "
        >
          Votre
        </div>
        <div>
          <select
            style="
         border-radius: 20px;
        background: black;
        color: white;
        border: none;
        background: #333436 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        opacity: 1;
        padding: 5px;
          "
            v-model="comparison"
          >
            <option value="" disabled>Enveloppe</option>
            <option style="color:black" v-for="(comparison, index) in comparisons_platforms" :key="index" :value="comparison">{{ comparison.platform_contract_name }}</option>
          </select>
        </div>
        <div
          style="
          text-align: left;
          font: normal normal normal Segoe UI;
          letter-spacing: 0px;
          color: #ffffff;
          opacity: 1;
          margin-left: 10px;
        "
        >
          en pilote automatique
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-5">
      <b-col cols="10" md="4" class="spCardContainer">
        <b-row class="header"><b-col class="title">Votre {{ comparison.platform_contract_name }}</b-col></b-row>
        <div class="content mt-4">
          <b-row class="title">
            <b-col style="text-align: left;">Vos titres</b-col>
            <b-col style="text-align: right;">Répartition</b-col>
          </b-row>
          <b-row v-for="(alternative, i) in comparison.securities" :key="i">
              <b-col v-if="alternative.hasOwnProperty('security')" cols="8" style="text-align: left;" id="random">
                <div v-if="(Math.round(alternative.weight * 100) / 100)  > 0">
                  {{ alternative.security.name }}
                </div>
              </b-col>
              <b-col v-if="alternative.hasOwnProperty('security')" cols="4" style="text-align: right;">
                <div v-if="(Math.round(alternative.weight * 100) / 100)  > 0">
                  {{ Math.round(alternative.weight) }}%
                </div>
              </b-col>
          </b-row>
        </div>
        <b-row class="mt-4">
          <b-col cols="8" md="6" class="m-auto"><b-button>Vision laser</b-button></b-col>
        </b-row>
      </b-col>
      <b-col cols="10" md="4">
        <div
          style="text-align: center;
            font: normal normal bold Segoe UI;
            letter-spacing: 0px;
            color: #9561E2;
            opacity: 1;    height: 100%;
            display: flex;
            flex-direction: column;
    justify-content: center;"
        >
          <div>
            <div
              style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;color:#333436"
              class="h1 mb-2"
            >
              <b-icon-arrow-left style="margin-left:40px"></b-icon-arrow-left>
              <b-icon-arrow-right style="margin-right:40px"></b-icon-arrow-right>
            </div>
            <div>
              Comparer mes portefeuilles
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="10" md="4" class="spCardContainer">
        <b-row class="header">
          <b-col class="title">
            <select
              class="form-control-4"
              style="
         border-radius: 20px;
        background: black;
        color: white;
        border: none;
        background: #333436 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        opacity: 1;
        padding: 5px;
          "
              v-model="save_portfolio"
            >
              <option value="null" disabled>Portefeuille sauvegardé</option>
              <option style="color:black" v-for="(save_portfolio, index) in filteredPlatformContract(comparison)" :key="index" :value="save_portfolio">{{ save_portfolio.portfolio_id }} -  {{ save_portfolio.date }} {{ save_portfolio.portfolio_name }} {{ comparison.platform_contract.contract.name }} {{ comparison.platform_contract.platform.name }}</option>
            </select>
          </b-col>
        </b-row>
        <div class="content mt-4">
          <b-row class="title">
            <b-col style="text-align: left;">Vos titres</b-col>
            <b-col style="text-align: right;">Répartition</b-col>
          </b-row>
          <b-row v-for="(save, i) in save_portfolio.portfolio_saves" :key="i">
            <b-col v-if="save.hasOwnProperty('security')" cols="8" style="text-align: left;" id="random">
              {{ save.security.name }}
            </b-col>
            <b-col cols="4" style="text-align: right;"> {{ Math.round(save.weight * 100) }}% </b-col>
          </b-row>
        </div>
      </b-col>
    </div>

    <div class="row spCardBigContainer justify-content-center mt-4 pb-4 pt-4">
      <div class="row spCardBigTitle">Recommandations pour suivre votre portefeuille optimisé</div>
      <div class="row mt-4">
        <b-col cols="7" class="title">
          <b-row class="row contentBg">
            <b-col cols="4">Acheter titres :</b-col>
            <b-col cols="8" style="filter: blur(5px);">
              <div>Acheter titres :</div>
              <div>Acheter titres :</div>
            </b-col>
          </b-row>
          <div class="row contentBg mt-2">
            <b-col cols="4">Vendre titres :</b-col>
            <b-col cols="8" style="filter: blur(5px);">
              <div>Acheter titres :</div>
              <div>Acheter titres :</div>
            </b-col>
          </div>
        </b-col>
        <b-col cols="5">
          <div class="contentBg activate">
            <b-button
              v-b-modal="'my-modal' + this.uid"
              style="background: transparent;text-align: center;
font: normal normal bold 1.7em Segoe UI;
letter-spacing: 0px;
color: #9561E2;
opacity: 1;border:none"
              >Activer le pilote automatique</b-button
            >
          </div>
        </b-col>
      </div>
      <div class="row mt-4 justify-content-between" style="filter: blur(5px);width: 100%;">
        <div class="col-md-4 col-sm-12 m-auto"><b-button class="btnCard">Vision laser</b-button></div>
        <div class="col-md-4 col-sm-12 m-auto"><b-button class="btnCard">Vision laser</b-button></div>
        <div class="col-md-4 col-sm-12 m-auto"><b-button class="btnCard">Vision laser</b-button></div>
      </div>
    </div>

    <b-modal centered modal-class="dbpModal" hide-footer title="Pilote automatique" :id="'my-modal' + this.uid" size="xl">
      <img :src="require('./popupcomingsoon.png')" alt="popupcomingsoon" style="width: 100%;" />
    </b-modal>

  </b-container>
</template>

<script>
    export default {
        props: [
            'comparisons',
            'comparisons_platforms',
            'accessgranted',
            'token',
            'route',
        ],
        data() {
            return {
                save_portfolios: [],
                comparison: this.comparisons_platforms[0],
                comps_plats: this.comparisons_platforms,
                save_portfolio: [],
                access:"",
                show: false,
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            for (let key in this.comps_plats)
            {
                this.temp_array = []
                this.temp_array.push(this.comps_plats[key]['portfolio_saved'])
                this.temp_array.push(this.comps_plats[key]['platform_contract_id'])
                this.save_portfolios.push(this.temp_array)
            }
            this.access = this.accessgranted;
        },

  mounted() {
    for (let key in this.comps_plats) {
      this.temp_array = [];
      this.temp_array.push(this.comps_plats[key]["portfolio_saved"]);
      this.temp_array.push(this.comps_plats[key]["platform_contract"]['id']);
      this.save_portfolios.push(this.temp_array);
      //this.save_portfolios.push(this.comps_plats[key]["portfolio_saved"]);
    }
    this.access = this.accessgranted;
  },

  methods: {
    modalId(i) {
      return "modal" + i;
    },
    filteredPlatformContract(comparison) {
      this.filters_save_portfolios = [];
      this.save_filter = [];
      if (comparison.platform_contract.id != null) {
        this.save_portfolios.forEach((save_portfolio) => {
          if (save_portfolio[1] === comparison.platform_contract.id) {
            this.filters_save_portfolios.push(save_portfolio[0]);
          }
        });
        return this.filters_save_portfolios[0];
      } else {
        return [];
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../../sass/_variables.scss";
.dbpModal {
  button {
    color: $purple_color;
    background: transparent;
    border: none;
    font-weight: bold;
    &:focus {
      border: none;
      background: transparent;
    }
    &:active {
      border: none;
      background: transparent;
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
  }
  .modal-body {
    text-align: justify;
  }
  .modalContentCustom {
    text-align: justify;
  }
}
.spCardBigContainer {
  background: #333436 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
  backdrop-filter: blur(8px);
  .spCardBigTitle {
    text-align: center;
    font: normal normal bold $mf_ft_size_big_subtitle Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    opacity: 1;
  }
  .contentBg {
    background: #242527 0% 0% no-repeat padding-box;
    border-radius: 20px;
    opacity: 1;
    color: $mf_ft_color_white;
  }
  .activate {
    text-align: center;
    font: normal normal bold $mf_ft_size_title Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    opacity: 1;
  }
  .btnCard {
    background: $purple_color 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 41px;
    opacity: 1;
    width: 90%;
    border: none;
    margin: 5px;
  }
}

.spCardContainer {
  background: #333436 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
  //   margin: 15px;
  padding: 30px;

  .header {
    .title {
      text-align: center;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }
  }
  .content {
    .title {
      text-align: center;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
    }
    padding: 10px;
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    border-radius: 20px;
    opacity: 1;
    background: #242527 0% 0% no-repeat padding-box;
  }
  .btn {
    background: $purple_color 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 41px;
    opacity: 1;
    border: none;
    width: 100%;
  }
}
</style>
